module.exports = __webpack_public_path__ + "static/media/bullets.25964725.svg";